import { useState, useEffect } from 'react';
import { Platform, Keyboard } from 'react-native';

/**
 * React hook for keyboard visibility events.
 *
 * @returns Keyboard visibility state and a method to dismiss the keyboard.
 */
export function useKeyboard() {
  const [visible, setVisible] = useState<boolean>();
  const keyboardShowEvent = Platform.OS === 'ios' ? 'keyboardWillShow' : 'keyboardDidShow';
  const keyboardHideEvent = Platform.OS === 'ios' ? 'keyboardWillHide' : 'keyboardDidHide';
  const dismiss = () => {
    Keyboard.dismiss();
    setVisible(false);
  };

  useEffect(() => {
    const onKeyboardDidShow = () => {
      setVisible(true);
    };

    const onKeyboardDidHide = () => {
      setVisible(false);
    };

    Keyboard.addListener(keyboardShowEvent, onKeyboardDidShow);
    Keyboard.addListener(keyboardHideEvent, onKeyboardDidHide);

    return () => {
      Keyboard.removeListener(keyboardShowEvent, onKeyboardDidShow);
      Keyboard.removeListener(keyboardHideEvent, onKeyboardDidHide);
    };
  }, [keyboardHideEvent, keyboardShowEvent]);

  return [visible, dismiss];
}
